(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    var dataEl  = document.getElementById('lb-data');
    var overlay = document.getElementById('lb-overlay');
    if (!dataEl || !overlay) return;

    var images = [];
    try { images = JSON.parse(dataEl.textContent) || []; } catch (e) { images = []; }
    if (!images.length) return;

    /* Immutable master list (all product images). `images` becomes the
       CURRENT working set, which sections/product.liquid may narrow via
       window.updateLightboxImages() when a variant's media grouping applies. */
    var allImages = images.slice();

    var modal     = document.getElementById('lb-modal');
    var closeBtn  = document.getElementById('lb-close');
    var prevBtn   = document.getElementById('lb-prev');
    var nextBtn   = document.getElementById('lb-next');
    var wrap      = document.getElementById('lb-image-wrap');
    var image     = document.getElementById('lb-image');
    var thumbsEl  = document.getElementById('lb-thumbs');
    var maxZoom   = parseFloat(overlay.dataset.maxZoom) || 3;

    /* Host-page hooks (optional) */
    var pageThumbs = document.querySelectorAll('[data-lightbox-thumb]');

    var single = images.length <= 1;
    if (prevBtn) prevBtn.disabled = single;
    if (nextBtn) nextBtn.disabled = single;

    /* ── State ── */
    var idx = 0, lastFocus = null, activeTrigger = null;
    var zoom = 1, panX = 0, panY = 0;
    var drag = false, dragX = 0, dragY = 0, dragPX = 0, dragPY = 0;

    /* ── Zoom helpers ── */
    function apply(animate) {
      image.classList.toggle('no-transition', !animate);
      image.style.transform = 'scale(' + zoom + ') translate(' + panX + 'px, ' + panY + 'px)';
      wrap.classList.toggle('is-zoomed', zoom > 1);
    }
    function clamp() {
      var r = wrap.getBoundingClientRect();
      var mx = r.width  * (zoom - 1) / (2 * zoom);
      var my = r.height * (zoom - 1) / (2 * zoom);
      panX = Math.max(-mx, Math.min(mx, panX));
      panY = Math.max(-my, Math.min(my, panY));
    }
    function reset() {
      zoom = 1; panX = 0; panY = 0;
      apply(true);
      wrap.classList.remove('is-zoomed', 'is-dragging');
    }

    /* ── Navigation ── */
    function goTo(i) {
      if (i < 0) i = images.length - 1;
      if (i >= images.length) i = 0;
      idx = i;
      reset();
      image.classList.add('is-loading');
      image.src = images[i].src;
      image.alt = images[i].alt || '';

      /* Sync host page thumbnails */
      pageThumbs.forEach(function (t) {
        t.classList.toggle('is-active', (parseInt(t.dataset.index, 10) || 0) === i);
      });

      /* Sync modal thumbnail strip */
      if (thumbsEl) {
        thumbsEl.querySelectorAll('.lb-thumb').forEach(function (t, ti) {
          var a = ti === i;
          t.classList.toggle('is-active', a);
          if (a) t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        });
      }
    }

    image.addEventListener('load', function () { image.classList.remove('is-loading'); });

    /* ── Open / Close ── */
    function open(startIdx) {
      lastFocus = document.activeElement;
      goTo(typeof startIdx === 'number' ? startIdx : 0);
      overlay.classList.add('is-visible');
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (window.trapFocus) window.trapFocus(modal);
    }

    function close() {
      if (window.releaseFocus) window.releaseFocus(modal);
      overlay.classList.remove('is-open');
      var onEnd = function () {
        overlay.classList.remove('is-visible');
        overlay.removeEventListener('transitionend', onEnd);
      };
      overlay.addEventListener('transitionend', onEnd);
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      reset();

      /* Sync the host page's main image (the <img> inside the clicked trigger)
         to the last-viewed image */
      var main = activeTrigger ? activeTrigger.querySelector('img') : null;
      if (main && images[idx]) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = images[idx].src;
        main.alt = images[idx].alt || '';
      }
      if (lastFocus) { lastFocus.focus(); lastFocus = null; }
    }

    /* ── Open triggers (host page elements) ── */
    document.querySelectorAll('[data-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activeTrigger = trigger;
        var start = 0;
        pageThumbs.forEach(function (t) {
          if (t.classList.contains('is-active')) start = parseInt(t.dataset.index, 10) || 0;
        });
        open(start);
      });
    });

    /* ── Close / navigate ── */
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn)  prevBtn.addEventListener('click',  function () { goTo(idx - 1); });
    if (nextBtn)  nextBtn.addEventListener('click',  function () { goTo(idx + 1); });

    if (thumbsEl) {
      thumbsEl.addEventListener('click', function (e) {
        var t = e.target.closest('.lb-thumb');
        if (t) goTo(parseInt(t.dataset.index, 10));
      });
    }

    /* ── Keyboard ── */
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape')     { close(); return; }
      if (e.key === 'ArrowLeft')  { goTo(idx - 1); return; }
      if (e.key === 'ArrowRight') { goTo(idx + 1); return; }
    });

    /* ── Zoom: wheel ── */
    wrap.addEventListener('wheel', function (e) {
      e.preventDefault();
      zoom = Math.min(maxZoom, Math.max(1, zoom + (e.deltaY < 0 ? 0.25 : -0.25)));
      if (zoom === 1) { panX = 0; panY = 0; } else clamp();
      apply(false);
    }, { passive: false });

    /* ── Zoom: double-click toggle ── */
    var lastClick = 0;
    wrap.addEventListener('click', function (e) {
      var now = Date.now();
      var dbl = now - lastClick < 300;
      lastClick = dbl ? 0 : now;
      if (!dbl) return;
      e.stopPropagation();
      if (zoom > 1) {
        reset();
      } else {
        zoom = maxZoom;
        var r = wrap.getBoundingClientRect();
        panX = -((e.clientX - r.left - r.width  / 2) / zoom);
        panY = -((e.clientY - r.top  - r.height / 2) / zoom);
        clamp();
        apply(true);
      }
    });

    /* ── Pan: mouse drag ── */
    wrap.addEventListener('mousedown', function (e) {
      if (zoom <= 1) return;
      e.preventDefault();
      drag = true;
      dragX = e.clientX; dragY = e.clientY;
      dragPX = panX; dragPY = panY;
      wrap.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!drag) return;
      panX = dragPX + (e.clientX - dragX) / zoom;
      panY = dragPY + (e.clientY - dragY) / zoom;
      clamp();
      image.classList.add('no-transition');
      image.style.transform = 'scale(' + zoom + ') translate(' + panX + 'px, ' + panY + 'px)';
    });
    document.addEventListener('mouseup', function () {
      if (!drag) return;
      drag = false;
      wrap.classList.remove('is-dragging');
    });

    /* ── Pan/zoom: touch ── */
    var tX = 0, tY = 0, tPX = 0, tPY = 0, pinchD = 0, pinchZ = 1, tapT = 0;
    function dist(t) {
      var dx = t[0].clientX - t[1].clientX;
      var dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    wrap.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { pinchD = dist(e.touches); pinchZ = zoom; return; }
      tX = e.touches[0].clientX; tY = e.touches[0].clientY;
      tPX = panX; tPY = panY;
      var now = Date.now();
      if (now - tapT < 300) {
        e.preventDefault();
        if (zoom > 1) { reset(); } else { zoom = maxZoom; clamp(); apply(true); }
        tapT = 0;
      } else { tapT = now; }
    }, { passive: true });
    wrap.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        zoom = Math.min(maxZoom, Math.max(1, pinchZ * (dist(e.touches) / pinchD)));
        if (zoom === 1) { panX = 0; panY = 0; } else clamp();
        apply(false);
        return;
      }
      if (zoom <= 1) return;
      e.preventDefault();
      panX = tPX + (e.touches[0].clientX - tX) / zoom;
      panY = tPY + (e.touches[0].clientY - tY) / zoom;
      clamp();
      image.classList.add('no-transition');
      image.style.transform = 'scale(' + zoom + ') translate(' + panX + 'px, ' + panY + 'px)';
    }, { passive: false });

    /* ── Gallery grouping API (used by sections/product.liquid) ── */
    window.getLightboxImages = function () {
      return allImages.slice();
    };

    window.updateLightboxImages = function (subset) {
      images = (subset && subset.length) ? subset : allImages.slice();
      idx = 0;

      var single2 = images.length <= 1;
      if (prevBtn) prevBtn.disabled = single2;
      if (nextBtn) nextBtn.disabled = single2;

      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        images.forEach(function (im, i) {
          var thumbBtn = document.createElement('button');
          thumbBtn.type = 'button';
          thumbBtn.className = 'lb-thumb' + (i === 0 ? ' is-active' : '');
          thumbBtn.dataset.index = String(i);
          var thumbImg = document.createElement('img');
          thumbImg.src = im.src;
          thumbImg.alt = im.alt || '';
          thumbImg.loading = 'lazy';
          thumbBtn.appendChild(thumbImg);
          thumbsEl.appendChild(thumbBtn);
        });
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-utils"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var Pushmax = window.Pushmax || {};

    /* Money format string from shop settings, surfaced via #pushmax-config.
       Cached after first read. Empty string when unavailable. */
    function defaultMoneyFormat() {
      if (Pushmax._moneyFormat != null) return Pushmax._moneyFormat;
      var cfg = document.getElementById('pushmax-config');
      Pushmax._moneyFormat = (cfg && cfg.dataset.moneyFormat) || '';
      return Pushmax._moneyFormat;
    }

    Pushmax.formatMoney = function (cents, format) {
      var fmt = format || defaultMoneyFormat();
      var amount = (cents / 100).toFixed(2);
      /* Fallback when no Shopify money format is available. */
      if (!fmt) return '$' + amount;
      return fmt
        .replace(/\{\{amount\}\}/g, amount)
        .replace(/\{\{amount_no_decimals\}\}/g, Math.round(cents / 100))
        .replace(/\{\{amount_with_comma_separator\}\}/g, amount.replace('.', ','));
    };

    Pushmax.escapeHTML = function (str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    /* min(50, inventory) when inventory is tracked and not overselling, else 50. */
    Pushmax.getMaxQty = function (management, policy, quantity) {
      if (management && policy !== 'continue' && quantity > 0) {
        return Math.min(50, quantity);
      }
      return 50;
    };

    /* Rewrite a Shopify CDN image URL to a sized variant, e.g. '_400x' before the
       extension. Pass size like '400x' or '120x160'. */
    Pushmax.shopifyImgSrc = function (src, size) {
      if (!src) return '';
      return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + size + '$1$2');
    };

    /* Find the variant whose ordered options match `options`. Operates on the
       /products/handle.js shape where each variant has an `options` array. */
    Pushmax.findVariant = function (product, options) {
      return product.variants.find(function (v) {
        return options.every(function (opt, i) { return v.options[i] === opt; });
      }) || null;
    };

    /* Clamp a qty stepper's value to maxQty and toggle its +/- buttons.
       Pass the inner qty element; expects a .ui-qty wrapper with
       [data-qty-dec]/[data-qty-inc] buttons. Preserves the current value. */
    Pushmax.applyQtyMax = function (qtyInput, maxQty) {
      if (!qtyInput) return;
      var max = maxQty || 50;
      qtyInput.max = max;
      var cur = parseInt(qtyInput.value, 10) || 1;
      if (cur > max) { qtyInput.value = max; cur = max; }
      var wrap = qtyInput.closest('.ui-qty');
      var dec  = wrap ? wrap.querySelector('[data-qty-dec]') : null;
      var inc  = wrap ? wrap.querySelector('[data-qty-inc]') : null;
      if (dec) dec.disabled = (cur <= 1);
      if (inc) inc.disabled = (cur >= max);
    };

    window.Pushmax = Pushmax;

    /* ── A11y utilities — focus trap + screen-reader announcer ──
       Used by global-header (nav drawer), cart-drawer, quick-add, bundle-quick-add. ── */
    var _a11ySelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    window.trapFocus = function (el) {
      var focusable = Array.prototype.slice.call(el.querySelectorAll(_a11ySelector));
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      function handler(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
        }
      }
      el._a11yTrapHandler = handler;
      el.addEventListener('keydown', handler);
      first.focus();
    };

    window.releaseFocus = function (el) {
      if (el && el._a11yTrapHandler) {
        el.removeEventListener('keydown', el._a11yTrapHandler);
        el._a11yTrapHandler = null;
      }
    };

    window.announceA11y = function (msg) {
      var el = document.getElementById('a11y-announcer');
      if (!el) return;
      /* Clear first so repeated identical messages still fire */
      el.textContent = '';
      requestAnimationFrame(function () { el.textContent = msg; });
    };

    /*
     * window.addToCart — shared cart utility used sitewide.
     * Callers: sections/product.liquid, sections/quick-add.liquid,
     *          sections/bundle-quick-add.liquid, sections/bundle-product-page.liquid.
     *
     * Signature: window.addToCart(variantId, onSuccess, onError [, qty [, properties]])
     *   variantId  {number}  — Shopify variant ID (required)
     *   onSuccess  {fn}      — called after successful add (optional)
     *   onError    {fn}      — called on network/API error (optional)
     *   qty        {number}  — quantity to add (default: 1)
     *   properties {object}  — line-item properties, e.g. { "Size": "M" } (default: {})
     *
     * Cart count badge is refreshed automatically on every successful add via
     * window.updateCartCount, exposed by sections/cart-drawer.liquid.
     */
    window.addToCart = function (variantId, onSuccess, onError, qty, properties) {
      var quantity = (qty && qty > 0) ? qty : 1;
      var props    = (properties && typeof properties === 'object') ? properties : {};

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: variantId, quantity: quantity, properties: props })
      })
      .then(function (res) {
        return res.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (e) {}
          if (res.status >= 400) throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');
        });
      })
      .then(function () {
        /* Refresh cart count badge on every successful add */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (window.updateCartCount) window.updateCartCount(cart.item_count); })
          .catch(function () {});
        if (onSuccess) onSuccess();
      })
      .catch(function (err) {
        if (onError) onError(err);
      });
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ui-quantity-input"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Quantity stepper: delegate to each .ui-qty wrapper */
    document.addEventListener('click', function (e) {
      var decBtn = e.target.closest('[data-qty-dec]');
      var incBtn = e.target.closest('[data-qty-inc]');
      var btn = decBtn || incBtn;
      if (!btn) return;

      var wrapper = btn.closest('.ui-qty');
      if (!wrapper) return;

      var input = wrapper.querySelector('.ui-qty__input');
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var min     = parseInt(input.min, 10)   || 1;
      var max     = parseInt(input.max, 10)   || Infinity;

      if (decBtn) current = Math.max(min, current - 1);
      if (incBtn) current = Math.min(max, current + 1);

      input.value = current;

      /* Update dec button disabled state */
      var dec = wrapper.querySelector('[data-qty-dec]');
      if (dec) dec.disabled = (current <= min);

      /* Update inc button disabled state */
      var inc = wrapper.querySelector('[data-qty-inc]');
      if (inc) inc.disabled = (current >= max);

      /* Dispatch change so parent sections can react */
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
